(() => {
  'use strict';
  if (window.ucwPrinterListsInitialized) return;
  window.ucwPrinterListsInitialized = true;
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root) || !window.UCWPrinterCatalog) return;
    const { create, normalize, compare } = window.UCWPrinterCatalog;
    const find = key => root.querySelector(`[data-printer-${key}]`);
    const list = find('list'), search = find('search'), seriesTrack = root.querySelector('[data-series-track]');
    const loader = find('background-loader'), loaderText = find('loader-text'), heading = find('results-heading');
    const retry = find('retry'), noResults = find('no-results'), top = find('back-to-top');
    const groups = new Map(), entries = new Map(), lifecycle = new AbortController();
    let state, frame = 0, scrollFrame = 0;
    const signal = lifecycle.signal;
    const moveTo = element => element?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    function groupFor(item) {
      if (groups.has(item.key)) return groups.get(item.key);
      const element = document.createElement('div'); element.className = 'printer-group'; element.dataset.printerSeries = item.key;
      const group = { element, items: [], name: item.series || 'Overige modellen' };
      if (item.series) {
        const header = document.createElement('div'); header.className = 'printer-group__header';
        const title = document.createElement('h2'); title.className = 'printer-category'; title.dataset.series = item.series;
        title.id = `${root.id}-serie-${groups.size}`; title.textContent = `${root.dataset.printermerk || ''} ${item.series}-serie`.trim();
        const back = document.createElement('a'); back.className = 'printer-group__top-link'; back.href = `#${root.id}`; back.textContent = 'Terug naar boven';
        header.append(title, back); element.append(header); group.title = title;
      }
      group.list = document.createElement('ul'); group.list.className = 'printer-list' + (root.dataset.currentType === 'type' ? ' ucw-finder__models' : ''); element.append(group.list);
      groups.set(item.key, group); return group;
    }
    function filter() {
      const searchField = find('search-field');
      if (searchField) searchField.hidden = entries.size < 30;
      const query = normalize(search?.value), searching = Boolean(query); let count = 0;
      root.classList.toggle('is-searching', searching);
      for (const group of groups.values()) {
        let visible = 0;
        for (const item of group.items) {
          const matches = !query || item.search.includes(query); item.node.hidden = !matches;
          item.node.classList.toggle('is-search-match', searching && matches); if (matches) visible++;
        }
        group.element.hidden = !visible; count += visible;
      }
      if (heading) {
        heading.hidden = !searching;
        heading.textContent = `${count} ${root.dataset.currentType === 'printer' ? (count === 1 ? 'printer' : 'printers') : (count === 1 ? 'resultaat' : 'resultaten')} gevonden${state.status === 'complete' ? '.' : '; de lijst is nog niet volledig.'}`;
      }
      noResults.hidden = count > 0 || state.status !== 'complete';
      noResults.textContent = searching ? (root.dataset.currentType === 'type' ? 'Geen resultaten. Controleer het merk en het volledige cartridge- of tonernummer.' : 'Geen resultaten. Controleer het merk en het volledige typenummer van uw printer.') : 'Er zijn geen resultaten beschikbaar.';
      if (seriesTrack) seriesTrack.closest('[data-printer-series-mount]').hidden = searching || (!groups.size && state.status !== 'loading');
    }
    function render() {
      frame = 0;
      const focused = root.contains(document.activeElement) ? document.activeElement : null;
      const focusedSeries = focused?.matches('button[data-series-key]') ? focused.dataset.seriesKey : '';
      for (const item of state.items) {
        if (entries.has(item.url)) continue;
        const group = groupFor(item), node = item.element.cloneNode(true);
        if (root.dataset.currentType === 'type') {
          const anchor = node.querySelector('a');
          if (anchor) { const arrow = document.createElement('span'); arrow.textContent = '›'; arrow.className = 'ucw-number-finder__arrow'; arrow.setAttribute('aria-hidden', 'true'); anchor.append(arrow); }
        }
        node.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        const entry = { ...item, node }; group.items.push(entry); entries.set(item.url, entry);
      }
      const sorted = [...groups.values()].sort((a, b) => compare(a.name, b.name));
      sorted.forEach(group => {
        group.items.sort((a, b) => compare(a.name, b.name));
        group.list.append(...group.items.map(item => item.node)); list.append(group.element);
      });
      if (seriesTrack) {
        const buttons = sorted.filter(group => group.title).map(group => {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'series-button';
          button.dataset.seriesTarget = group.title.dataset.series; button.dataset.seriesKey = group.element.dataset.printerSeries;
          button.textContent = `${root.dataset.printermerk || ''} ${group.name}`.trim(); return button;
        });
        seriesTrack.replaceChildren();
        const size = Math.max(1, Math.ceil(buttons.length / 3));
        for (let index = 0; index < buttons.length; index += size) {
          const column = document.createElement('div'); column.className = 'series-list__column'; column.append(...buttons.slice(index, index + size)); seriesTrack.append(column);
        }
      }
      loader.hidden = state.status === 'complete';
      loaderText.textContent = state.status === 'error' ? 'Een deel van de lijst kon niet worden geladen. Uw gevonden resultaten blijven beschikbaar.' : `De lijst wordt geladen (${state.loaded}/${state.total})…`;
      retry.hidden = state.status !== 'error'; root.setAttribute('aria-busy', String(state.status === 'loading'));
      if (root.dataset.showDebug === 'true') find('debug').textContent = `${entries.size} resultaten · ${state.loaded}/${state.total} batches · ${state.status}`;
      filter(); window.UCWPrinterComponents?.mark(list);
      if (focusedSeries) [...(seriesTrack?.querySelectorAll('[data-series-key]') || [])].find(button => button.dataset.seriesKey === focusedSeries)?.focus({ preventScroll: true });
      else if (focused?.isConnected && focused !== document.activeElement) focused.focus({ preventScroll: true });
      root.dispatchEvent(new CustomEvent('ucw:printerlist:batch-loaded', { bubbles: true, detail: { root, hasMore: state.status !== 'complete' } }));
    }
    const catalog = create(root.dataset.collectionUrl, next => { state = next; if (!frame) frame = requestAnimationFrame(render); });
    search?.addEventListener('input', filter, { signal });
    root.addEventListener('click', event => {
      const series = event.target.closest('[data-series-key]');
      if (series?.matches('button')) { if (search) search.value = ''; filter(); moveTo(groups.get(series.dataset.seriesKey)?.title); }
      if (event.target.closest('.printer-group__top-link') || event.target.closest('[data-printer-back-to-top]')) {
        event.preventDefault(); moveTo(root); search?.focus({ preventScroll: true });
      }
    }, { signal });
    retry.addEventListener('click', () => catalog.start(), { signal });
    document.addEventListener('ucw:printers-updated', () => window.UCWPrinterComponents?.mark(list), { signal });
    window.addEventListener('scroll', () => {
      if (!scrollFrame) scrollFrame = requestAnimationFrame(() => { scrollFrame = 0; const rect = root.getBoundingClientRect(); top.hidden = rect.top > -250 || rect.bottom < 0; });
    }, { passive: true, signal });
    instances.set(root, () => { lifecycle.abort(); catalog.dispose(); cancelAnimationFrame(frame); cancelAnimationFrame(scrollFrame); instances.delete(root); });
    catalog.start();
  }
  const scan = (scope = document) => scope.querySelectorAll('[data-ucw-printerlijst]').forEach(init);
  scan(); document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ucw-printerlijst]').forEach(root => instances.get(root)?.()));
})();
